__turbopack_context__.v({
  "accent": "Tag-module-scss-module__xpQQYq__accent",
  "brand": "Tag-module-scss-module__xpQQYq__brand",
  "danger": "Tag-module-scss-module__xpQQYq__danger",
  "gradient": "Tag-module-scss-module__xpQQYq__gradient",
  "info": "Tag-module-scss-module__xpQQYq__info",
  "l": "Tag-module-scss-module__xpQQYq__l",
  "m": "Tag-module-scss-module__xpQQYq__m",
  "neutral": "Tag-module-scss-module__xpQQYq__neutral",
  "s": "Tag-module-scss-module__xpQQYq__s",
  "success": "Tag-module-scss-module__xpQQYq__success",
  "tag": "Tag-module-scss-module__xpQQYq__tag",
  "warning": "Tag-module-scss-module__xpQQYq__warning",
});
